/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChunkEditResponse
 */
export interface ChunkEditResponse {
    /**
     * 
     * @type {string}
     * @memberof ChunkEditResponse
     */
    message: string;
}

/**
 * Check if a given object implements the ChunkEditResponse interface.
 */
export function instanceOfChunkEditResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ChunkEditResponseFromJSON(json: any): ChunkEditResponse {
    return ChunkEditResponseFromJSONTyped(json, false);
}

export function ChunkEditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkEditResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function ChunkEditResponseToJSON(value?: ChunkEditResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

